import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Fix ResizeObserver loop error (known issue with Radix UI/shadcn Select)
// This patches the ResizeObserver to debounce notifications
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = this;
    clearTimeout(tid);
    tid = setTimeout(() => callback.apply(ctx, args), delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super(debounce(callback, 20));
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
